<template>
    <div id="portfolio-page-container">
        
        <div id="portfolio-works-images-container">
            <!--Yapılan değişiklik imageInfoList, portfolioInfoListFiltered olarak değişti-->
            <div v-for="(imageInfo, index) in portfolioInfoListFiltered" :key="imageInfo.imageName" class="image-container">
                <img :src="getImagePath(imageInfo.imageName)" :alt="imageInfo.imageName" @click="openOverlay(index)">
            </div>
        </div>

        <!-- Overlay -->
        <div v-if="isOverlayVisible" class="overlay" @click="closeOverlay">
            <div class="overlay-content" @click.stop>
                <button class="btn" @click="prevImage">
                    <p> ❮ </p>
                </button>

                <div class="overlay-image-container">
                    <!--Yapılan değişiklik imageInfoList, portfolioInfoListFiltered olarak değişti-->
                    <!--
                    <img 
                    :src="getImagePath(imageInfoList[currentImageIndex].imageName)" 
                    :alt="imageInfoList[currentImageIndex].imageName" 
                    class="overlay-image">
                    -->

                    <img 
                    :src="getImagePath(portfolioInfoListFiltered.at(currentImageIndex).imageName)" 
                    :alt="portfolioInfoListFiltered.at(currentImageIndex).imageName" 
                    class="overlay-image">
                
                    <div class="work-info">
                        <!--Yapılan değişiklik imageInfoList, portfolioInfoListFiltered olarak değişti-->
                        <p>
                            <!--{{ getImageInfo(imageInfoList[currentImageIndex].imageName) }}-->
                            {{ portfolioInfoListFiltered.at(currentImageIndex).imageInfo }}
                        </p>
                    </div>
                </div>
                
                <button class="btn" @click="nextImage">
                   <p> ❯ </p> 
                </button>
            </div>
        </div>

    </div>
</template>

<script>
//import axios from 'axios';
import { usePortfolioPageStore } from '../stores/portfolioPageStore';

export default{
    
    data(){
        return{
            store: usePortfolioPageStore(),
            isOverlayVisible: false,
            currentImageIndex: null, // Hangi resme tıklanacağını tutacak
            //yeni kaldırılan yer başlangıç
            imageInfoList: [] // API'den gelen bilgileri tutacak
            //yeni kaldırılan yer bitiş
        }
    },
    computed: {
        portfolioInfoListFiltered() {
            return this.store.filteredImages;
        }
    },
    methods:{
        getImagePath(fileName) {
            return `/portfolio-images/${fileName}`;
        },
        openOverlay(index) {
            this.currentImageIndex = index;
            this.isOverlayVisible = true; // Overlay'i göster
        },
        closeOverlay() {
            this.isOverlayVisible = false; // Overlay'i kapat
        },
        prevImage(){
            if (this.currentImageIndex === 0) {
                // İlk resimden önceki resme geçiş: Son resme git
                //yeni kaldırılılan yer başlangıç
                //this.currentImageIndex = this.imageInfoList.length - 1;
                //yeni kaldırılılan yer bitiş
                this.currentImageIndex = this.portfolioInfoListFiltered.length - 1;
            } else {
                // Önceki resme geç
                this.currentImageIndex--;
            }
        },
        nextImage(){
            //if (this.currentImageIndex === this.imageInfoList.length - 1) {
            if(this.currentImageIndex === this.portfolioInfoListFiltered.length - 1) {
                // Son resimden sonraki resme geçiş: İlk resme git
                this.currentImageIndex = 0;
            } else {
                // Sonraki resme geç
                this.currentImageIndex++;
            }
        },
        //yeni kaldırılan yer başlangıç
        /*async fetchImageInfo() {
            try {
                const response = await axios.get("/api/portfolio/get-images");
                this.imageInfoList = response.data; // API'den gelen bilgileri atıyoruz
            } catch (error) {
                console.error("API call failed:", error);
            }
        },*/
        //yeni kaldırılan yer bitiş
        getImageInfo(fileName) {
            const image = this.store.data.find(img => img.imageName === fileName);
            return image ? image.imageInfo : "No information";
        }
    },
    async created(){
        // API'den image bilgilerini al

        //yeni kaldırılan yer başlangıç
        //await this.fetchImageInfo();
        //yeni kaldırılan yer bitiş

        //yeni eklenen yer başlangıç
        await this.store.fetchPortfolioData();
        //yeni eklenen yer bitiş
    }
}
</script>

<style scoped>
    #portfolio-page-container{
        width: 100vw;
        height: 100vh;
        padding: 0;
        margin: 0;
        border: 1px solid rgb(27, 27, 27); /*Arkaplan resmi gözükmemesi için konuldu. */
        background-color: rgb(27, 27, 27);
        /* border: 1px solid #2D2C2A; */ /*Arkaplan resmi gözükmemesi için konuldu. */
        /* background-color: #2D2C2A; */

        display: flex;
        flex-direction: column;
        overflow: scroll;
    }

    #portfolio-works-images-container{
        width: 90%;
        margin-top: 1%;
        margin-left: 5%;

        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-evenly;
    }

    .image-container{
        width: 250px; 
        height: 300px;
        border-radius: 1%;
        padding: 0%;  
        margin-bottom: 5%;   
    }

    .image-container img{
        width: 250px; 
        height: 300px; 
        margin: auto;
        object-fit: contain;
        border-radius: 1%;
        cursor: pointer;
    }

    /* Overlay */
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .overlay-content {
        position: relative;
        width: auto;
        border: 1%;
        border-radius: 1%;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .overlay-image-container{
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .btn{
        width: 30px;
        background: none;
        border: none;
        cursor: pointer;
    }

    .btn p{
        font-size: 20px;
        font-weight: 900;
        color: white;
    }

    .work-info p{
        color: white;
    }

    .overlay-image {
        width: 450px;
        height: 525px;
        object-fit: contain;
        margin-left: 0px;
        padding: 0px;
    }

    /* Mobil Cihazlar İçin */
    @media (max-width: 768px) {
        /* Overlay */
        .overlay-image{
            width: 340px;
        }
    }
</style>